export default {
  headingcomponent: 'h2',
  headingVariant: 'headingLarge',
  descriptionVariant: 'bodyLarge',
};
